import { useAuth } from '../contexts/AuthContext';

/** Login yapan kullanıcının Silme İzni (canDelete) açıksa true. Kapalı veya yoksa false. */
export function useCanDelete(): boolean {
  const { user } = useAuth();
  return user?.canDelete !== false;
}
